import * as petRuleset from '../pet.ruleset';
import { petSchema } from '../pet.schema';
import * as petStatsModifiers from './petStats.modifiers';
import { ReplicantModuleState } from '../../../utils';

export type PetStats = typeof PetStats;
// eslint-disable-next-line no-redeclare
export namespace PetStats {
  export const schema = petSchema({ ruleset: petRuleset });
  export const modifiers = petStatsModifiers;

  export type MutableState = ReplicantModuleState<PetStats>;
}
